import storage from 'dibs-browser-storage';
import get from 'lodash.get';

const types = {
    UNREGISTERED: {
        FIRST_TIME: 'unregistered:first-time',
        RETURNING: 'unregistered:returning',
    },
    VIP: {
        ALL: 'vip:all',
    },
    CONSUMER: {
        SUSPECTED_TRADE: 'consumer:suspected-trade',
        NO_PURCHASES: 'consumer:no-purchases',
        PURCHASED: 'consumer:purchased',
    },
    TRADE: {
        LAST_MONTH: 'trade:approved-last-month',
        NO_PURCHASES: 'trade:no-purchases',
        PURCHASED: 'trade:purchased',
    },
};

const BUYER_STATUS_CONFIRMED_MULTIPLE = 'CONFIRMED_MULTIPLE';
const BUYER_STATUS_CONFIRMED_ONE = 'CONFIRMED_ONE';
const BUYER_STATUS_SUBMITTED = 'SUBMITTED';
const BUYER_STATUS_INITIATED = 'INITIATED';
const BUYER_STATUS_NONE = 'NONE';
const FIRM_LOYALTY_STATUS_ELIGIBLE = 'ELIGIBLE';

const getTradeBuyerUserType = ({ firmLoyaltyStatus, verifiedTradeSubStatus }) => {
    let userType = types.TRADE.NO_PURCHASES;

    if (firmLoyaltyStatus === FIRM_LOYALTY_STATUS_ELIGIBLE) {
        userType = types.TRADE.PURCHASED;
    } else if (
        verifiedTradeSubStatus &&
        verifiedTradeSubStatus.indexOf('VERIFIED_IN_LAST_30_DAYS') !== -1
    ) {
        userType = types.TRADE.LAST_MONTH;
    }

    return userType;
};

const getConsumerUserType = (buyerStatus, verifiedTradeStatus = '') => {
    let userType = types.CONSUMER.NO_PURCHASES;

    if (verifiedTradeStatus && verifiedTradeStatus.indexOf('SUSPECTED') !== -1) {
        userType = types.CONSUMER.SUSPECTED_TRADE;
    } else if (buyerStatus.indexOf('CONFIRMED') !== -1) {
        userType = types.CONSUMER.PURCHASED;
    }

    return userType;
};

const getBuyerStatusFromTransactions = ({
    initiatedTransactions,
    submittedTransactions,
    confirmedTransactions,
}) => {
    let buyerStatus;

    if (confirmedTransactions && confirmedTransactions.totalResults > 0) {
        buyerStatus = BUYER_STATUS_CONFIRMED_MULTIPLE;
    } else if (confirmedTransactions && confirmedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_CONFIRMED_ONE;
    } else if (submittedTransactions && submittedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_SUBMITTED;
    } else if (initiatedTransactions && initiatedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_INITIATED;
    } else {
        buyerStatus = BUYER_STATUS_NONE;
    }

    return { buyerStatus };
};

export const getUnregisteredUserType = () => {
    const { localStorage } = storage;
    const { totalVisitCount } = localStorage.getItem('visitCount') || {};
    const { session } = localStorage.getItem('pseudoSessionVisitCount') || {};

    return totalVisitCount > session ? types.UNREGISTERED.RETURNING : types.UNREGISTERED.FIRST_TIME;
};

export const getRegisteredUserType = (user, viewer) => {
    const { initiatedTransactions, submittedTransactions, confirmedTransactions } = viewer;
    const { isVip, isVerifiedTrade, verifiedTradeStatus, verifiedTradeSubStatus } = user;

    if (isVip) {
        return types.VIP.ALL;
    }

    const { buyerStatus } = getBuyerStatusFromTransactions({
        initiatedTransactions,
        submittedTransactions,
        confirmedTransactions,
    });

    if (isVerifiedTrade) {
        return getTradeBuyerUserType({
            firmLoyaltyStatus: get(user, 'tradeFirm.loyalty.status'),
            verifiedTradeSubStatus: verifiedTradeSubStatus,
        });
    }

    return getConsumerUserType(buyerStatus, verifiedTradeStatus);
};
